export default "__VITE_ASSET__6274de1e__"